import styled, { css } from 'styled-components';
import { devices } from 'styles/devices';

const Paragraph = styled.p`
   ${({ size }) =>
      size === 'XL' &&
      css`
         font-size: 16px;
      `}
   display: block;
   font-weight: 400;
   font-size: 14px;
   line-height: 1.5;
   height: 85px;
   ${devices.tabletL} {
      font-size: 16px;
   }
`;

export default Paragraph;
